import { ItemCategoryApiResponse } from '@app/api/category/types';
import { TransformToCamelCase } from '@app/types/general';
import { Status } from 'easyship-components';

export type CategoryHSOption = {
  value: string;
  label: string;
  fullName: string;
};

export type CategoryHSCategoryOption = CategoryHSOption &
  TransformToCamelCase<ItemCategoryApiResponse>;

export type CategoryHSCodeSuggested = {
  code: string;
  description?: string;
};

export type CategoryHSSuggestedOption = CategoryHSCodeSuggested & CategoryHSOption;

export interface CategoryHSCodeSearchProps {
  className?: string;
}

export type CategoryHSCodeSelectionValue = CategoryHSCategoryOption | CategoryHSSuggestedOption;

export enum CategoryHSCodeState {
  DROPDOWN = 'dropdown',
  SEARCH = 'search',
}

export enum PortalVerticalDirection {
  UP = 'up',
  DOWN = 'down',
}

export type PortalPositionState = {
  top?: number;
  bottom?: number;
  left: number;
  width: number;
  direction: PortalVerticalDirection;
  isOpen: boolean;
  componentState: CategoryHSCodeState;
};

export type Category10DigitEnabled = {
  is10DigitCodeEnabled?: boolean;
};

export type CategoryHSCodeSelectionProps = {
  value?: Partial<CategoryHSCodeSelectionValue>;
  onChange?: (value: CategoryHSCodeSelectionValue) => void;
  className?: string;
  classNameDropdown?: string;
  classNameSearch?: string;
  classNamePortal?: string;
  status?: Status;
} & Category10DigitEnabled;
